import { clearSelectedGeometry } from "./clearSelectedGeometry";
import { drawingStore } from "../store";

export const clearDrawingAndSelectedGeometry = () => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  clearSelectedGeometry();
  store.dispatch(actions.clearDrawingTool());
};
